import { render, staticRenderFns } from "./user_zx_detial.vue?vue&type=template&id=077c4ccd&scoped=true"
import script from "./user_zx_detial.vue?vue&type=script&lang=js"
export * from "./user_zx_detial.vue?vue&type=script&lang=js"
import style0 from "./user_zx_detial.vue?vue&type=style&index=0&id=077c4ccd&prod&scoped=true&lang=less"
import style1 from "./user_zx_detial.vue?vue&type=style&index=1&id=077c4ccd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077c4ccd",
  null
  
)

export default component.exports